import { handleError } from "../error";
import {
    REMOVE_DATATABLE_CONFIRM_STATE,
    SET_DATATABLE_CONFIRM_STATE,
    SET_DATATABLE_LOADING,
    REFRESH_DATATABLE_UPDATED_AT,
    DATATABLE_CONFIRM_ON_CHANGE
} from "../../types";
import Axios from "axios";
import { handleResponse } from "../response";
const get = {
    msg: ({ action, title }) =>
        `Are you sure you want to ${action} ${title ?? ""}? Only an administrator can undo this.`,
    action: ({ action, path, id }) => `/${path}/${action}/${id}`,
    loadingMsg: ({ action }) => `CONFIRMING ${action.toUpperCase()}`
};

export const dispatchAction = () => async(dispatch, getState) => {
    try {
        dispatch({ type: SET_DATATABLE_LOADING });
        const { datatable: { confirmState: { action } } } = getState();
        switch (action) {
            default:
                await dispatch(confirmAction());
                break;
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
    finally {
        dispatch(removeConfirmState());
        // await dispatch({ type: REMOVE_DATATABLE_LOADING });
        dispatch({ type: REFRESH_DATATABLE_UPDATED_AT });
    }
};

export const confirmAction = () => async(dispatch, getState) => {
    try {
        const { datatable: { confirmState: { action_url, modal_comment, property_id } } } = getState();

        const response = await Axios.post(action_url, {
            ["modal-comment"]: modal_comment,
            property_id,
            reactAPI: true
        });

        await dispatch(handleResponse(response));
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const setConfirmState = (event, message = null) => async(dispatch) => {
    try {
        const { dataset: { action, id, path, name: title } } = event.target;
        switch (action) {
            default: {
                const newState = {
                    title: `CONFIRM ${action.toUpperCase()}.`,
                    message: message ? message : get.msg({
                        action,
                        title
                    }),
                    action_url: get.action({
                        action,
                        path,
                        id
                    }),
                    action,
                    loading_message: get.loadingMsg({ action })
                };
                dispatch({
                    type: SET_DATATABLE_CONFIRM_STATE,
                    payload: newState
                });
                break;
            }
        }
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const onChange = event => (dispatch) => {
    try {
        dispatch({
            type: DATATABLE_CONFIRM_ON_CHANGE,
            payload: { [event.target.name]: event.target.value }
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const removeConfirmState = () => async dispatch => {
    try {
        dispatch({ type: REMOVE_DATATABLE_CONFIRM_STATE });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};
